import axios from 'axios';
import {BASE_API_URL} from "settings";

export const strapi = axios.create({
    baseURL: `${BASE_API_URL}/api`
})